import { toast } from "react-toastify";
import { api } from "../../Lib/constants";
import {
  ADD_SPECIALDAY,
  ADD_SPECIALDAY_FAILED,
  ADD_SPECIALDAY_SUCCESS,
  SPECIALDAY,
  SPECIALDAY_FAILED,
  SPECIALDAY_SUCCESS,
  UPDATE_SPECIALDAY,
  UPDATE_SPECIALDAY_FAILED,
  UPDATE_SPECIALDAY_SUCCESS,
} from "./actionTypes";
import { getAuthHeader } from "../../Lib/utils";

export const getSpecialday = () => async (dispatch) => {
  dispatch({
    type: SPECIALDAY,
  });
  try {
    const response = await api(
      `specialday/specialdayList`,
      "get",
      {},
      getAuthHeader()
    );
    if (response?.data) {
      dispatch({
        type: SPECIALDAY_SUCCESS,
        payload: response.data,
      });
    } else {
      throw new Error("No data received from server");
    }
    return response;
  } catch (error) {
    console.error("Error fetching Specialday list:", error);
    toast.error(error?.message || "Failed to fetch special days");
    dispatch({
      type: SPECIALDAY_FAILED,
      payload: error?.message || "Failed to fetch special days",
    });
  }
};

export const addSpeicalday = (data) => async (dispatch) => {
  dispatch({
    type: ADD_SPECIALDAY,
  });
  try {
    let response = await api(`specialday/add`, "post", data, getAuthHeader());
    console.log("add specialday data", response);
    toast.success("Added Successfully");
    dispatch({
      type: ADD_SPECIALDAY_SUCCESS,
      payload: response?.data,
    });
    dispatch(getSpecialday());
    return response;
  } catch (error) {
    console.log("while Adding specialday error ====>>>", error);
    toast.error(error?.message);
    return dispatch({
      type: ADD_SPECIALDAY_FAILED,
      payload: error?.message,
    });
  }
};

export const updateSpecialday = (id, data) => async (dispatch) => {
  dispatch({
    type: UPDATE_SPECIALDAY,
  });
  try {
    let response = await api(
      `specialday/update/${id}`,
      "put",
      data,
      getAuthHeader()
    );
    console.log("update specialday data", response);
    toast.success("Updated Successfully");
    dispatch({
      type: UPDATE_SPECIALDAY_SUCCESS,
      payload: response?.data,
    });
    dispatch(getSpecialday());
    return response;
  } catch (error) {
    console.log("while updating specialday error ====>>>", error);
    toast.error(error?.message);
    return dispatch({
      type: UPDATE_SPECIALDAY_FAILED,
      payload: error?.message,
    });
  }
};
